import type { ReactNode } from 'react';
import { Card, Col, Row } from 'ui';

type P = {
  left: ReactNode;
  right: ReactNode;
  top: ReactNode;
};

const EventRsvpButtonsDetailLayout = ({ left, right, top }: P) => (
  <Card>
    <Row gutter={['xs', 'xs']}>
      <Col span={24} textAlign="center">
        {top}
      </Col>
      <Col span={12}>{left}</Col>
      <Col span={12}>{right}</Col>
    </Row>
  </Card>
);

export default EventRsvpButtonsDetailLayout;
